/**
 * Copyright © 2026 Adnuntius AS.
 */
import {SignalResourceListBindingService} from '../../common/controller/signal-resource-list-binding.service';
import {DestroyRef, inject, Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import template from './layout-selector-modal.component.html';
import {LayoutApiService} from '../layout/layout-api.service';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {APP_SHARED} from '../../common/app-shared';
import {ADMIN_RESOURCE_PAGES} from '../../common/controller/admin-resource-pages';
import {ADMIN_LIST} from '../../common/directives/admin-list';
import {LayoutComponentSummaryComponent} from '../../common/layout-component-summary-component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule, TranslateModule, ...ADMIN_LIST, ...ADMIN_RESOURCE_PAGES, LayoutComponentSummaryComponent],
  selector: 'adn-layout-selector-modal',
  template
})
export class LayoutSelectorModalComponent implements OnInit {
  private readonly listLifetime = inject(DestroyRef);
  /** Set via BsModalService initialState */
  currentLayouts: any[] = [];

  readonly onSaved = new Subject<any[]>();

  selLayouts: any[] = [];
  listState: import('../../common/controller/signal-admin-resource-list-state').SignalAdminResourceListState<any>;
  get items(): any[] { return this.listState?.items() || []; }
  get hasItems(): boolean { return this.items.length > 0; }

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LayoutApiService) private Layout: LayoutApiService,
    private listBinding: SignalResourceListBindingService,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.selLayouts = _.cloneDeep(this.currentLayouts);
    this.listBinding.create(this.Layout, '', this.listLifetime, {
      baseTable: 'layout',
      moreParams: {includeInactive: false, includeHidden: false},
      afterFill: () => {
        _.forEach(this.items, (item: any) => {
          item.selected = this.selLayouts.some((layout) => layout.id === item.id);
        });

      }
    }, this);
  }

  select(item: any): void {
    item.selected = true;
    this.selLayouts.push(item);
  }

  deselect(item: any): void {
    item.selected = false;
    _.remove(this.selLayouts, (l: any) => l.id === item.id);
    _.forEach(this.items, (it: any) => {
      if (it.id === item.id) {
        it.selected = false;
      }
    });
  }

  saveChanges(): void {
    this.onSaved.next(this.selLayouts);
    this.bsModalRef.hide();
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }
}
